import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import { useAuth } from '../../../common/hooks/useAuth';
import { Role } from '../../../common/spdCore/authorization/roles';

export const MergingExaminedLink = (props: { examinedId: string }) => {
  const nav = useNavigation();
  const auth = useAuth();

  if (!auth.check([Role.Admin])) {
    return null;
  }

  return (
    <OverlayTrigger overlay={<Tooltip>Sklejanie badanych</Tooltip>}>
      <Button
        onClick={e => {
          e.stopPropagation();
          void nav.mergeExamined(props.examinedId);
        }}
        variant="btn-info"
      >
        <Icon.Diagram2 />
      </Button>
    </OverlayTrigger>
  );
};
